import React, { useState } from 'react';
import { useDialogsContext } from '../../../contexts/Dialog';
import { BankType } from '../../../Types';
import { useMobile } from 'frontend/src/hooks/useMobile';
import companyInfo from '../../../themes/themes';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import Cards from './Cards';
import Loading from './Loading';

export default function ChooseBankOption({
  openPlaidDialog,
  openWise,
  goBack = () => {},
}: {
  openPlaidDialog: (...args) => void;
  openWise: (...args) => void;
  goBack?: (...args) => void;
}) {
  const theme = process.env.REACT_APP_THEME;
  const dialog: any = useDialogsContext();
  const [loading, setLoading] = useState(false);
  const mobile = useMobile('sm');

  function handleClose() {
    dialog.close('chooseBankOption');
    setLoading(false);
  }

  function closeAndGoBack() {
    handleClose();
    goBack();
  }

  function onContinue(bankType: string) {
    if (bankType === BankType.plaid) {
      openPlaidDialog(handleClose);
    }
    if (bankType === BankType.wise) {
      setLoading(true);
      let windowRef;
      if (mobile) {
        windowRef = window.open();
      }
      openWise(handleClose, windowRef);
    }
  }

  return (
    <Dialog
      open={dialog.chooseBankOption}
      onClose={closeAndGoBack}
      header="Connect Bank"
      description={`Select a bank type to connect to ${companyInfo[theme].company}:`}
      maxWidth={500}
      actions={<Loading loading={loading} />}
    >
      <Cards loading={loading} setBankType={onContinue} />
    </Dialog>
  );
}
